import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Row, Col, Space, Input, Select, Tooltip, Pagination } from "antd";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { appointmentService } from "../../../services";
import dayjs from "dayjs";
import { ROLES } from "../../../constants";
import { changeDocumentTitle } from "../../../utils/title";

function CustomerAppointments() {

    const role = localStorage.getItem('role')
    const [search, setSearch] = useState(null)
    const [loading, setLoading] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });

    const options = [
        {
            value: "10",
            label: "10",
        },
        {
            value: "25",
            label: "25",
        },
        {
            value: "50",
            label: "50",
        },
    ];

    const columns = [
        {
            title: "S.No",
            dataIndex: "s.no",
            key: "s.no",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date) => dayjs(date).format("DD, MMM-YYYY"),
        },
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status, record) => {
                const { approved, reject, pending } = record;
                // Conditionally render tags based on the status
                return (
                    <Space>
                        {status === 2 && (
                            // If status is 2, show "Canceled"
                            <Tag
                                color="#F04949"
                                style={{ fontSize: "12px", padding: "5px 5px" }}
                            >
                                Canceled
                            </Tag>
                        )}
                        {/* // Otherwise, show Approved, Reject, and Pending based on their
            counts */}
                        <>
                            {approved > 0 && (
                                <Tag
                                    color="green"
                                    style={{ fontSize: "10px", padding: "2px 15px", borderRadius: "24px", border: "none" }}
                                >
                                    Approved ({approved})
                                </Tag>
                            )}
                            {reject > 0 && (
                                <Tag
                                    color="red"
                                    style={{ fontSize: "10px", padding: "2px 15px", borderRadius: "24px", border: "none" }}
                                >
                                    Reject ({reject})
                                </Tag>
                            )}
                            {pending > 0 && (
                                <Tag
                                    color="yellow"
                                    style={{ fontSize: "10px", padding: "2px 20px", borderRadius: "24px", border: "none" }}
                                >
                                    Pending ({pending})
                                </Tag>
                            )}
                        </>
                    </Space>
                );
            },
        },
        {
            title: "Actions",
            key: "Actions",
            render: (text, record) => (
                <Link to={role === ROLES.CUSTOMER ? `/customers-portal/appointments/view/${record.id}` : `/operations/appointment/view/${record.id}`} className="hover:text-primary">
                    <Tooltip title='View'>
                        {/* <Button type="primary" size="small"> */}
                        <EyeOutlined style={{ fontSize: "16px" }} />
                        {/* </Button> */}
                    </Tooltip>
                </Link>
            ),
        },
    ];

    const initialize = async (page = 1, pageSize = pagination.pageSize, search = null) => {
        setLoading(true);
        const { success, data } = await appointmentService.fetch(page, pageSize, search);
        if (success) {
            setAppointments(data.data);
            setPagination((prev) => ({
                ...prev,
                total: data.total,
                current: page,
                pageSize,
            }));
        }
        setLoading(false);
    };


    useEffect(() => {
        changeDocumentTitle("Appointments");

        initialize(pagination.current, pagination.pageSize, search);
    }, [search]);

    return (
        <>
            {/* <div className="flex justify-end text-right mb-4 p-0">
                <Link to={"/customers-portal/appointments/add-appointments"}>
                    <Button type="primary" >Add Appointment</Button>
                </Link>
            </div> */}
            <div className="customer1-table-wrapper" >
                <div className="flex justify-end">
                    <Input
                        placeholder="Search Appointment"
                        prefix={<SearchOutlined />}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ width: "25%", height: "40px", borderRadius: "24px", margin: "6px" }}
                    />
                </div>
                <Table
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    dataSource={appointments}
                    rowKey="id"
                    style={{ marginTop: "10px" }}
                    loading={loading}
                    pagination={false}
                    footer={() => (
                        <div className="flex justify-between items-center">
                            <div className="text-xs text-gray-600">
                                Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                                {pagination.total} entries
                            </div>

                            <Pagination
                                current={pagination.current}
                                total={pagination.total}
                                pageSize={pagination.pageSize}
                                showSizeChanger={false}
                                onChange={(page) => initialize(page, pagination.pageSize, search)}
                                itemRender={(current, type, originalElement) => {
                                    if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                    if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                    return originalElement;
                                }}
                            />
                        </div>
                    )}
                // pagination={{
                //     current: pagination.current,
                //     total: pagination.total,
                //     pageSize: pagination.pageSize,
                //     onChange: (page) => initialize(page, pagination.pageSize, search),
                //     showSizeChanger: false,
                // }}
                />
            </div>
        </>

    );
}

export default CustomerAppointments;
